module.exports = __webpack_public_path__ + "static/media/DancingGran.79772042.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/DancingGran.gif
// module id = 254
// module chunks = 0